import './css/main.css'

import Experience from './js/Experience.js'

const experience = new Experience(document.getElementById('main-canvas'))